import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const ETOFOR_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/etofor/logo.png",
        alt: "Eugene Therapy and Oregon Counseling Logo",
        style: { width: "130px", height: "100%", isMobile: { width: "100px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 43,
  state: "OR",
  departmentIds: [251, 260, 266],
};
